import React from 'react';
import DecorativeLeaves from '../components/DecorativeLeaves';
import './AboutPage.css';

export default function AboutPage() {
  return (
    <section className="about-page">
      <DecorativeLeaves config="about" />
      <div className="about-container">
        <div className="mission-section">
          <div className="mission-card animate-fade-in">
            <h2 className="mission-title">Our Mission</h2>
            <p className="mission-text">
              TheTopia is a Minecraft event network designed to deliver fun, competitive, and creative experiences
              for players of all skill levels. We believe that amazing gaming experiences should be accessible to everyone,
              which is why we've built our network on the principle of absolute fairness.
            </p>
          </div>
        </div>

        <div className="highlight-section">
          <div className="highlight-card animate-scale-in delay-1">
            <div className="highlight-icon"></div>
            <h2 className="highlight-title">Zero Queue Priority</h2>
            <p className="highlight-text">
              At TheTopia, <strong>everyone has an equal chance</strong>. We don't offer queue priority,
              pay-to-win advantages, or any features that give some players an unfair edge over others.
              When an event opens, every player has the exact same opportunity to participate, we're first come first serve.
            </p>
          </div>
        </div>

        <div className="features-section">
          <h2 className="section-title animate-slide-up delay-2">What We Offer</h2>
          <div className="features-grid">
            <div className="feature-card animate-scale-in delay-3">
              <div className="feature-icon">
                <i className="mdi mdi-trophy"></i>
              </div>
              <h3 className="feature-title">Custom Events</h3>
              <p className="feature-description">
                Unique, hand-crafted events designed to challenge and entertain. From large-scale creator
                events, to staff-hosted competitions, there's always something exciting happening.
              </p>
            </div>
            <div className="feature-card animate-scale-in delay-4">
              <div className="feature-icon">
                <i className="mdi mdi-scale-balance"></i>
              </div>
              <h3 className="feature-title">Fair Competition</h3>
              <p className="feature-description">
                Every player starts on equal footing. No pay-to-win mechanics, no unfair advantages.
                Your success depends entirely on your skills and strategy, annnddd a bit of luck :)
              </p>
            </div>
            <div className="feature-card animate-scale-in delay-5">
              <div className="feature-icon">
                <i className="mdi mdi-account-group"></i>
              </div>
              <h3 className="feature-title">Amazing Community</h3>
              <p className="feature-description">
                Join a welcoming community of players who share your passion for Minecraft Events.
                Make friends, form teams, and practice your skills together.
              </p>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
}
